import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaHome, FaFileAlt } from 'react-icons/fa';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [registrationData, setRegistrationData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    const storedRegistrationId = sessionStorage.getItem('registrationId');
    const storedSessionId = sessionStorage.getItem('sessionId');

    // Verify the session matches what we stored
    if (sessionId && (sessionId === storedSessionId || storedRegistrationId)) {
      // You can fetch registration details here if needed
      setRegistrationData({
        registrationId: storedRegistrationId,
        sessionId: sessionId
      });
      
      // Clear session storage
      sessionStorage.removeItem('registrationId');
      sessionStorage.removeItem('sessionId');
    }
    
    setLoading(false);
  }, [searchParams]);

  const handleGoHome = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <div className="payment-success-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  return (
    <div className="payment-success-container">
      <div className="success-card">
        <div className="success-icon">
          <FaCheckCircle />
        </div>
        
        <h1>Payment Successful!</h1>
        <p className="success-message">
          Thank you for your registration! Your payment has been processed successfully.
        </p>
        
        {registrationData && (
          <div className="registration-details">
            <h3>Registration Details</h3>
            <div className="detail-row">
              <span>Registration ID:</span>
              <strong>#{registrationData.registrationId}</strong>
            </div>
            <div className="detail-row">
              <span>Session ID:</span>
              <strong>{registrationData.sessionId}</strong>
            </div>
          </div>
        )}
        
        <div className="success-info">
          <p>
            <FaFileAlt className="info-icon" />
            You will receive a confirmation email shortly with your registration details.
          </p>
        </div>
        
        <div className="action-buttons">
          <button onClick={handleGoHome} className="btn btn-primary">
            <FaHome className="btn-icon" />
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;

